import { Component, OnInit, Inject, ViewChild } from '@angular/core'
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import {CasoTareaModel, CasoTareaService} from 'src/app/services/casos_tareas.service';
import { VerTareaComponent } from '../ver-tarea/ver-tarea.component';
import { TareaCasoMixedModel, TareaCasoModel, TareaCasoService } from 'src/app/services/tareacaso.service';
import { TareaModel, TareasService } from 'src/app/services/tareas.service';
import { NoAprobarComentario } from '../no-aprobar-comentario/no-aprobar-comentario';
import {NotificacionService} from 'src/app/services/notificaciones.service';

@Component({
  selector:'casos-aprobar',
  templateUrl: './casos-aprobar.component.html',
  styleUrls:['./casos-aprobar.component.css']
})
export class CasosAprobarComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  displayedColumns: string[] = ['caso', 'fecha_solicitud','comentario', 'opciones'];
  dataSource = new MatTableDataSource<any>();
  search:string = ''
  casos: CasoTareaModel[] = []
  casosOriginal: CasoTareaModel[] = []

  constructor(
    public _casos: CasoTareaService,
    public dialog: MatDialog,
    public  _tareacaso: TareaCasoService,
    public  _tareas: TareasService,
    public _notification: NotificacionService
  ){}

  ngOnInit(){
    this.getCasos()
  }

  async getCasos(){
    this.casos = (await this._casos.getAprobacion().toPromise()).reverse()
    console.log(this.casos)
    this.loadCasos()
  }

  loadCasos() {
    this.dataSource = new MatTableDataSource<any>(this.casos)
    this.dataSource.paginator = this.paginator
    this.dataSource.sort = this.sort
  }

  filter(){
    this.casosOriginal === null ? this.casosOriginal = this.casos : null
    this.casos = this.casosOriginal
    this.casos = this.casos.filter((historia:any)=>JSON.stringify(historia).toLowerCase().indexOf(this.search.toLowerCase()) !== -1)
    this.loadCasos()
  }


  async findTareaAprobacion(caso: CasoTareaModel){
    const tareascasos: TareaCasoModel[] = await this._tareacaso.getByCaso(caso._id).toPromise()
    const tareas: TareaModel[] = await this._tareas.getByTipoCaso(caso.tipo_caso).toPromise()
    const tarea: any = tareas.find((tarea:TareaModel)=> tarea.titulo === 'Aprobar Evaluación del Especialista')
    const tareaAprobacion: TareaCasoModel = tareascasos.find((tareacaso: TareaCasoModel) => tareacaso.idTarea === tarea._id)
    
    tarea.idCaso = caso._id
    tarea.estado_caso = tareaAprobacion.estado
    tarea.tareacasoId = tareaAprobacion._id
    tarea.observaciones_text = tareaAprobacion.observaciones_text
    tarea.files = tareaAprobacion.files
    tarea.lastUser = tareaAprobacion.lastUser
    tarea.orden_prioridad = tareaAprobacion.orden_prioridad
    tarea.estafa = tareaAprobacion.estafa
    tarea.personalInternoInvolucrado = tareaAprobacion.personalInternoInvolucrado
    tarea.createdAt = tareaAprobacion.createdAt
    tarea.updatedAt = tareaAprobacion.updatedAt
    return tarea
  }

  async aprobar(caso: CasoTareaModel){
    const tarea = await this.findTareaAprobacion(caso)
    const dialogref = this.dialog.open(VerTareaComponent,{data:tarea,  disableClose: true })
    dialogref.afterClosed().subscribe(()=>this.ngOnInit())
  }

  guardarHistorialAprobacion(caso: CasoTareaModel,comentario:string){
    caso.historial.push({
      usuario: `${sessionStorage.getItem("correo")}`,
      realizo:`No aprobo el caso "${caso.numero_caso}" por: ${comentario}`,
      date: new Date()
    })
  }

  async noAprobar(caso: CasoTareaModel) {
    const dialogRef = this.dialog.open(NoAprobarComentario,{width:'400px',data:caso})
    dialogRef.afterClosed().subscribe(async (comentario: string)=>{
      if(comentario){
        caso.aprobacion = false
        this.guardarHistorialAprobacion(caso,comentario)
        caso.estado = 'En Ejecución'
        caso.solucion = 'No Determinado'
        await this._casos.put(caso._id,caso).toPromise()
        this._notification.rechazo(caso.asignadoAID, caso.numero_caso,comentario).toPromise()
        this.ngOnInit()
      }
    })
  }

}
